<div class="notfountparent">
		<div class="notfound-bg"></div>
		<div class="notfound">
			<div class="notfound-404">
				<h1>Payment Failed</h1>
			</div>
			<a routerLink="/" class="home-btn">Go Home</a>
			<a routerLink="/" class="contact-btn">Contact us</a>
		</div>
	</div>